import React, {FC, memo, useCallback, useMemo, useState,} from "react";
import {CoreContainer} from "../../../core";
import {ContextViewLayout} from "../context/components/contextViewLayout";
import {VotingRatingTab, VotingRatingTitle} from "./styles";
import {VotingEmpty} from "./VotingEmpty";
import {useHistory, useParams} from "react-router-dom";
import {useGetPollByParentEntity} from "../../hooks/api/useGetPollByParentEntity";
import {useGetCollectionCards} from "../../hooks/useGetCollectionCards";
import {Pagination} from "../../components/pagination";
import useQueryState from "../../hooks/useQueryState";
import {ProjectsGridNew} from "../../components/grids";
import {useTranslation} from "react-i18next";
import {translateStrangeObject} from "../../helpers/translateStrangeObject";
import {BREAKPOINTS, Skeleton, useBreakpoint} from "@brg/ui";
import {VotingCard} from "./VotingCard";
import { useTheme } from "styled-components";
import { useGetFriendlyUrlParam } from "shared/hooks/useGetFriendlyUrlParam";
import NavigateBackButton from "core/components/NavigateBackButton";
import { CreateLinkTo } from "shared/constants/linkTo";
const VotingRatingsPage: FC = () => {

    // карточки
    const id = useGetFriendlyUrlParam("id");
    const [{ page: currentPage = '1' }, setQueryParams] = useQueryState();
    const {i18n: {language}, t} = useTranslation()
    const isTablet = useBreakpoint(BREAKPOINTS.TABLET_MAX);
    const isSmall = useBreakpoint(BREAKPOINTS.TABLET_MIN);
    const theme = useTheme();
    const history = useHistory();
    
    const {resp: pollInfo, isLoading: pollLoading} = useGetPollByParentEntity(id);
    // @ts-ignore
    const {resp: cards, isLoading: cardsLoading} = useGetCollectionCards(pollInfo?.collectionInfo?.collectionId || '', pollInfo?.collectionInfo?.collectionType, pollInfo?.collectionInfo?.context, Number(currentPage || 1));

    const isLoading = useMemo(() => pollLoading || cardsLoading, [pollLoading, cardsLoading])

    if (!isLoading && !cards) return <VotingEmpty/>

    return <CoreContainer>
        <ContextViewLayout isHeaderHidden={true} isLoading={isLoading}>
            <NavigateBackButton text="вернуться к игре" backPath={() => history.push(CreateLinkTo.project(id))}/>
            {isLoading
                ? <Skeleton width={200} height={isSmall ? 28 : isTablet ? 51 : 70} />
                : <VotingRatingTitle color={theme.relatedTitle}>{translateStrangeObject(cards?.title, language)}</VotingRatingTitle>}
            {/* <VotingRatingTab>
                {isLoading
                    ? <Skeleton width={140} height={isMobile ? 16 : 22} />
                    : t('voting.cards') + ' ' + (cards?.items.paging?.count || 0)}
            </VotingRatingTab> */}
            <ProjectsGridNew isLoading={isLoading} withoutPaddingBottom>
                {cards?.items.data?.map((value: any, index: number) => (
                    <VotingCard cardData={value} key={index}/>
                ))}
            </ProjectsGridNew>
            <Pagination
                isLoading={isLoading}
                pages={cards?.items?.paging?.pages ?? 0}
                page={Number(currentPage)}
                onPageChange={(page) => {
                    setQueryParams({ page: page }, { replace: true })
                }}
                isCanLoadMore={currentPage < (cards?.items?.paging?.pages ?? 0)}
            />
        </ContextViewLayout>
    </CoreContainer>
}

export default memo(VotingRatingsPage);import React, {FC, memo, useCallback, useMemo, useState,} from "react";
import {CoreContainer} from "../../../core";
import {ContextViewLayout} from "../context/components/contextViewLayout";
import {VotingRatingTab, VotingRatingTitle} from "./styles";
import {VotingEmpty} from "./VotingEmpty";
import {useHistory, useParams} from "react-router-dom";
import {useGetPollByParentEntity} from "../../hooks/api/useGetPollByParentEntity";
import {useGetCollectionCards} from "../../hooks/useGetCollectionCards";
import {Pagination} from "../../components/pagination";
import useQueryState from "../../hooks/useQueryState";
import {ProjectsGridNew} from "../../components/grids";
import {useTranslation} from "react-i18next";
import {translateStrangeObject} from "../../helpers/translateStrangeObject";
import {BREAKPOINTS, Skeleton, useBreakpoint} from "@brg/ui";
import {VotingCard} from "./VotingCard";
import { useTheme } from "styled-components";
import { useGetFriendlyUrlParam } from "shared/hooks/useGetFriendlyUrlParam";
import NavigateBackButton from "core/components/NavigateBackButton";
import { CreateLinkTo } from "shared/constants/linkTo";
const VotingRatingsPage: FC = () => {

    // карточки
    const id = useGetFriendlyUrlParam("id");
    const [{ page: currentPage = '1' }, setQueryParams] = useQueryState();
    const {i18n: {language}, t} = useTranslation()
    const isTablet = useBreakpoint(BREAKPOINTS.TABLET_MAX);
    const isSmall = useBreakpoint(BREAKPOINTS.TABLET_MIN);
    const theme = useTheme();
    const history = useHistory();
    
    const {resp: pollInfo, isLoading: pollLoading} = useGetPollByParentEntity(id);
    // @ts-ignore
    const {resp: cards, isLoading: cardsLoading} = useGetCollectionCards(pollInfo?.collectionInfo?.collectionId || '', pollInfo?.collectionInfo?.collectionType, pollInfo?.collectionInfo?.context, Number(currentPage || 1));

    const isLoading = useMemo(() => pollLoading || cardsLoading, [pollLoading, cardsLoading])

    if (!isLoading && !cards) return <VotingEmpty/>

    return <CoreContainer>
        <ContextViewLayout isHeaderHidden={true} isLoading={isLoading}>
            <NavigateBackButton text="вернуться к игре" backPath={() => history.push(CreateLinkTo.project(id))}/>
            {isLoading
                ? <Skeleton width={200} height={isSmall ? 28 : isTablet ? 51 : 70} />
                : <VotingRatingTitle color={theme.relatedTitle}>{translateStrangeObject(cards?.title, language)}</VotingRatingTitle>}
            {/* <VotingRatingTab>
                {isLoading
                    ? <Skeleton width={140} height={isMobile ? 16 : 22} />
                    : t('voting.cards') + ' ' + (cards?.items.paging?.count || 0)}
            </VotingRatingTab> */}
            <ProjectsGridNew isLoading={isLoading} withoutPaddingBottom>
                {cards?.items.data?.map((value: any, index: number) => (
                    <VotingCard cardData={value} key={index}/>
                ))}
            </ProjectsGridNew>
            <Pagination
                isLoading={isLoading}
                pages={cards?.items?.paging?.pages ?? 0}
                page={Number(currentPage)}
                onPageChange={(page) => {
                    setQueryParams({ page: page }, { replace: true })
                }}
                isCanLoadMore={currentPage < (cards?.items?.paging?.pages ?? 0)}
            />
        </ContextViewLayout>
    </CoreContainer>
}

export default memo(VotingRatingsPage);